// Traduções da janela da viagem prevista — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'transporte.prevista.titulo': 'Conjunto com viagem em andamento',
    'transporte.prevista.tituloEscolha': 'Viagem prevista',
    'transporte.prevista.tituloRedefinir': 'Predecessora da viagem prevista',
    'transporte.prevista.explicacao': 'O conjunto já tem viagem em andamento. A nova linha pode ser cadastrada como viagem prevista, que vira Escalado sozinha quando a viagem anterior finalizar.',
    'transporte.prevista.comoFunciona': 'Cancelar não preenche o conjunto nesta linha. Viagem prevista abre a escolha da viagem que precisa finalizar antes.',
    'transporte.prevista.botaoPrevista': 'Viagem prevista',
    'transporte.prevista.escolhaTitulo': 'Escolha a viagem que precisa finalizar antes',
    'transporte.prevista.escolhaDica': 'Aparecem as viagens deste conjunto em andamento ou previstas que ainda não são predecessoras de outra. Finalizadas e apontadas ficam de fora.',
    'transporte.prevista.motorista': 'Conjunto de {{nome}}',
    'transporte.prevista.carregando': 'Carregando as viagens do conjunto',
    'transporte.prevista.erroCarregar': 'Não foi possível carregar as viagens do conjunto.',
    'transporte.prevista.tentarDeNovo': 'Tentar de novo',
    'transporte.prevista.nenhuma': 'Nenhuma viagem deste conjunto pode ser predecessora agora. A que está em andamento já tem outra prevista depois dela; escolha a última da sequência.',
    'transporte.prevista.conjuntoLivre': 'O conjunto não tem viagem em andamento nem prevista. A linha pode ser escalada agora.',
    'transporte.prevista.escalarAgora': 'Escalar agora',
    'transporte.prevista.gravar': 'Gravar como prevista',
    'transporte.prevista.trocar': 'Trocar predecessora',
    'transporte.prevista.data': 'Data',
    'transporte.prevista.origem': 'Origem',
    'transporte.prevista.destino': 'Destino',
    'transporte.prevista.maquina': 'Máquina',
    'transporte.prevista.dependeDe': 'Depende de',
    'transporte.prevista.atual': 'Atual',
    'transporte.prevista.feito': 'Viagem {{registro}} gravada como prevista, depois de {{predecessora}}.',
    'transporte.prevista.feitoTroca': 'A viagem {{registro}} passou a depender de {{predecessora}}.',
    'transporte.prevista.feitoEscalada': 'Previsão desfeita: a viagem {{registro}} foi escalada.',
    'transporte.prevista.feitoLivre': 'O conjunto ficou livre enquanto a janela estava aberta: a viagem {{registro}} foi escalada.',
  },
  en: {
    'transporte.prevista.titulo': 'Set with a trip in progress',
    'transporte.prevista.tituloEscolha': 'Planned trip',
    'transporte.prevista.tituloRedefinir': 'Predecessor of the planned trip',
    'transporte.prevista.explicacao': 'This set already has a trip in progress. The new row can be saved as a planned trip, which becomes Scheduled on its own when the previous trip is completed.',
    'transporte.prevista.comoFunciona': 'Cancel does not fill the set in this row. Planned trip opens the choice of the trip that must be completed first.',
    'transporte.prevista.botaoPrevista': 'Planned trip',
    'transporte.prevista.escolhaTitulo': 'Choose the trip that must be completed first',
    'transporte.prevista.escolhaDica': 'Trips of this set in progress or planned that are not yet predecessors of another one are listed. Completed and reported trips are left out.',
    'transporte.prevista.motorista': 'Set of {{nome}}',
    'transporte.prevista.carregando': 'Loading the trips of the set',
    'transporte.prevista.erroCarregar': 'The trips of the set could not be loaded.',
    'transporte.prevista.tentarDeNovo': 'Try again',
    'transporte.prevista.nenhuma': 'No trip of this set can be a predecessor now. The trip in progress already has another planned trip after it; choose the last one of the sequence.',
    'transporte.prevista.conjuntoLivre': 'The set has no trip in progress or planned. The row can be scheduled now.',
    'transporte.prevista.escalarAgora': 'Schedule now',
    'transporte.prevista.gravar': 'Save as planned',
    'transporte.prevista.trocar': 'Change predecessor',
    'transporte.prevista.data': 'Date',
    'transporte.prevista.origem': 'Origin',
    'transporte.prevista.destino': 'Destination',
    'transporte.prevista.maquina': 'Machine',
    'transporte.prevista.dependeDe': 'Depends on',
    'transporte.prevista.atual': 'Current',
    'transporte.prevista.feito': 'Trip {{registro}} saved as planned, after {{predecessora}}.',
    'transporte.prevista.feitoTroca': 'Trip {{registro}} now depends on {{predecessora}}.',
    'transporte.prevista.feitoEscalada': 'Plan undone: trip {{registro}} was scheduled.',
    'transporte.prevista.feitoLivre': 'The set became free while the window was open: trip {{registro}} was scheduled.',
  },
  es: {
    'transporte.prevista.titulo': 'Conjunto con viaje en curso',
    'transporte.prevista.tituloEscolha': 'Viaje previsto',
    'transporte.prevista.tituloRedefinir': 'Predecesor del viaje previsto',
    'transporte.prevista.explicacao': 'El conjunto ya tiene un viaje en curso. La nueva línea puede registrarse como viaje previsto, que pasa a Programado solo cuando el viaje anterior finalice.',
    'transporte.prevista.comoFunciona': 'Cancelar no completa el conjunto en esta línea. Viaje previsto abre la elección del viaje que debe finalizar antes.',
    'transporte.prevista.botaoPrevista': 'Viaje previsto',
    'transporte.prevista.escolhaTitulo': 'Elija el viaje que debe finalizar antes',
    'transporte.prevista.escolhaDica': 'Aparecen los viajes de este conjunto en curso o previstos que aún no son predecesores de otro. Finalizados y registrados quedan fuera.',
    'transporte.prevista.motorista': 'Conjunto de {{nome}}',
    'transporte.prevista.carregando': 'Cargando los viajes del conjunto',
    'transporte.prevista.erroCarregar': 'No fue posible cargar los viajes del conjunto.',
    'transporte.prevista.tentarDeNovo': 'Intentar de nuevo',
    'transporte.prevista.nenhuma': 'Ningún viaje de este conjunto puede ser predecesor ahora. El viaje en curso ya tiene otro previsto después; elija el último de la secuencia.',
    'transporte.prevista.conjuntoLivre': 'El conjunto no tiene viaje en curso ni previsto. La línea puede programarse ahora.',
    'transporte.prevista.escalarAgora': 'Programar ahora',
    'transporte.prevista.gravar': 'Guardar como previsto',
    'transporte.prevista.trocar': 'Cambiar predecesor',
    'transporte.prevista.data': 'Fecha',
    'transporte.prevista.origem': 'Origen',
    'transporte.prevista.destino': 'Destino',
    'transporte.prevista.maquina': 'Máquina',
    'transporte.prevista.dependeDe': 'Depende de',
    'transporte.prevista.atual': 'Actual',
    'transporte.prevista.feito': 'Viaje {{registro}} guardado como previsto, después de {{predecessora}}.',
    'transporte.prevista.feitoTroca': 'El viaje {{registro}} pasó a depender de {{predecessora}}.',
    'transporte.prevista.feitoEscalada': 'Previsión deshecha: el viaje {{registro}} fue programado.',
    'transporte.prevista.feitoLivre': 'El conjunto quedó libre mientras la ventana estaba abierta: el viaje {{registro}} fue programado.',
  },
}
